import KeyReturnPopup from 'containers/Warehouse/resignation/core/KeyReturnPopup'
import SignContractPopup from 'containers/OrderContract/SignContractPopup'
import ActivateAccountPopup from 'components/popups/ActivateAccountPopup'
import { useReduxDispatch, useReduxSelector } from 'store'
import VerificationPopup from './auth/VerificationPopup'
import useRestPopupState from 'hooks/useRestPopupState'
import { selectRest, showPopup } from 'rest/restSlice'
import { POPUPS as HomePopups } from 'containers/Home'
import { UNAUTHORIZED_TYPES } from 'utils/constants'
import { checkIsNativeApp } from 'utils/nativeApp'
import CameraModal from 'components/Player/Modal'
import useTranslation from 'hooks/useTranslation'
import BlockedCartPopup from './BlockedCartPopup'
import PasswordPopup from './auth/PasswordPopup'
import usePopupState from 'hooks/usePopupState'
import AuthPopup from './auth/BiometricPopup'
import Popup from 'components/popups/Popup'
import React, { useEffect } from 'react'
import NewMagPopup from './NewMagPopup'
import OtpPopup from './auth/OtpPopup'
import PinPopup from './auth/PinPopup'
import ErrorPopup from './ErrorPopup'
import NativeAuth from './NativeAuth'

const isNativeApp = checkIsNativeApp()
const Popups: React.FC = () => {
  return (
    <div className='popups'>
      <BasicPopups />
      <RestPopups />
    </div>
  )
}

const BasicPopups: React.FC = () => {
  const { popup } = usePopupState<string | { type: 'signContract' | 'signContract_subModal', props: { contractPdf: string, contractGroupId: string } } | { type: 'contractPreview', props: { contractPdf: string, isTemplate?: boolean } } | { type: 'activateAccount', props: { link: string } } | { type: 'camera', props: basic.CameraData } | { type: 'keyReturn', props: { warehouseId: string } }>()
  const { t } = useTranslation('home')

  if (popup && typeof popup === 'object' && (popup?.type === 'signContract' || popup?.type === 'signContract_subModal')) {
    return <SignContractPopup
      contractPdf={popup.props.contractPdf}
      contractGroupId={popup.props.contractGroupId}
    />
  }

  if (popup && typeof popup === 'object' && popup?.type === 'contractPreview') {
    return <SignContractPopup
      readOnly
      contractPdf={popup.props.contractPdf}
      isTemplate={popup.props.isTemplate}
    />
  }

  if (popup && typeof popup === 'object' && popup?.type === 'activateAccount') {
    return <ActivateAccountPopup
      link={popup.props.link}
    />
  }

  if (popup && typeof popup === 'object' && popup?.type === 'camera') {
    return <CameraModal
      camera={popup.props}
    />
  }

  if (popup && typeof popup === 'object' && popup?.type === 'keyReturn') {
    return <KeyReturnPopup
      warehouseId={popup.props.warehouseId}
    />
  }

  switch (popup) {
    case 'newMag': return <NewMagPopup />
    case 'blockedCart': return <BlockedCartPopup />
    case HomePopups.invest: return (
      <Popup>
        <div className='popup__title'>
          <i className='icon icon--logo s24' />
          <div>{t('comingSoon')}</div>
          <div>{t('youWillBeAbleToStartEarningWithUs')}</div>
        </div>
      </Popup>
    )

    case HomePopups.magStore: return (
      <Popup>
        <div className='popup__title'>
          <i className='icon icon--logo s24' />
          <div>{t('comingSoon')}</div>
          <div>{t('youWillBeAbleToGetRidOfUnnecessaryThingsFromYourApartment')}</div>
        </div>
      </Popup>
    )

    case HomePopups.magMobile: return (
      <Popup>
        <div className='popup__title'>
          <i className='icon icon--logo s24' />
          <div>{t('comingSoon')}</div>
          <div>{t('youWillBeAbleToRentAWarehouse')}</div>
        </div>

        <div className='popup__list'>
          <div className='list__title'>{t('allYouNeedToDoIs')}</div>
          <ul>
            <li>{t('youWillChooseThePeriodOfTimeDuringWhichYouWantTheWarehouseToRemainWithYou')}</li>
            <li>{t('youTellUsTheAddressWhereItShouldBeDelivered')}</li>
          </ul>
        </div>
      </Popup>
    )

    default: return null
  }
}

const RestPopups: React.FC = () => {
  const { isPopup, popupBody } = useReduxSelector(selectRest)
  const isPopupVisible = useRestPopupState(popupBody?.type)
  const dispatch = useReduxDispatch()

  useEffect(() => {
    if (isPopup) {
      const onPopState = () => { dispatch(showPopup()) }
      window.addEventListener('popstate', onPopState)
      return () => {
        window.removeEventListener('popstate', onPopState)
      }
    }
  }, [dispatch, isPopup])

  if (isPopupVisible) {
    if (isNativeApp && (popupBody?.type === UNAUTHORIZED_TYPES.webAuth)) return <NativeAuth />
    return <Popup isPopup={isPopup}>
      {(() => {
        switch (popupBody?.type) {
          case UNAUTHORIZED_TYPES.mail:
          case UNAUTHORIZED_TYPES.phone:
          case UNAUTHORIZED_TYPES.device: return <VerificationPopup />
          case UNAUTHORIZED_TYPES.mailOtp:
          case UNAUTHORIZED_TYPES.smsOtp: return <OtpPopup />
          case UNAUTHORIZED_TYPES.webAuth: return <AuthPopup />
          case UNAUTHORIZED_TYPES.warehousePin:
          case UNAUTHORIZED_TYPES.pin: return <PinPopup />
          case UNAUTHORIZED_TYPES.password: return <PasswordPopup />
          case 'formError': return <ErrorPopup />
          default: return null
        }
      })()}
    </Popup>
  }

  return null
}

export default Popups